import React, { useEffect, useState } from "react";
import {
  getImageFromIndexedDB,
  saveImageToIndexedDB,
} from "../utils/indexedDb";
import defaultProfilePic from "../assets/defaultProfilePic.png";

// Replace with actual AWS fetch function
const fetchImageFromS3 = async (memberId) => {
  // console.log("CALLING AWS FOR : " + memberId);
  const res = await fetch(
    `https://zpottergym.s3.ap-south-1.amazonaws.com/${memberId.substring(
      0,
      4
    )}/${memberId.substring(4)}?v=${Date.now()}`
    // { mode: "no-cors" }
  ); // Proxy through backend
  if (res.status === 404) return 404;
  const blob = await res.blob();
  return blob;
};

const MemberImage = ({
  memberId,
  expiryDate,
  imageUpdatedTimeFromDB,
  photoUploaded,
  width = "4rem",
  height = "4rem",
}) => {
  // console.log("inside MemberImage");
  // console.log(memberId);
  // console.log("scrolling MemberImage : " + memberId);
  const [imageURL, setImageURL] = useState(null);

  useEffect(() => {
    const loadImage = async () => {
      if (!memberId) return;
      const cached = await getImageFromIndexedDB(memberId);

      if (
        !cached ||
        cached.updatedTime < imageUpdatedTimeFromDB // Compare with DB time
      ) {
        // console.log("image NOT available in indexed DB : " + memberId);
        if (
          new Date(expiryDate) >
          new Date(new Date().setDate(new Date().getDate() - 30))
        ) {
          if (photoUploaded || photoUploaded === undefined) {
            const newImageBlob = await fetchImageFromS3(memberId);
            if (newImageBlob === 404) {
              await saveImageToIndexedDB(memberId, 404, new Date().getTime());
              setImageURL(null);
            } else {
              await saveImageToIndexedDB(
                memberId,
                newImageBlob,
                imageUpdatedTimeFromDB
              );
              const url = URL.createObjectURL(newImageBlob);
              setImageURL(url);
            }
          } else
            console.log(
              `condition not satisfied "photoUploaded || photoUploaded === undefined"`
            );
        } else {
          console.log("validity expired a month ago : " + memberId);
        }
      } else {
        // console.log("image available in indexed DB : " + memberId);
        if (cached.imageBlob === 404) setImageURL(null);
        else {
          const url = URL.createObjectURL(cached.imageBlob);
          setImageURL(url);
        }
      }
    };

    loadImage();
  }, [memberId]);

  return imageURL ? (
    <img
      src={imageURL}
      alt="Member"
      style={{ width: width, height: height, borderRadius: "10px" }}
    />
  ) : (
    <img
      src={defaultProfilePic}
      alt="Member"
      style={{ width: "3rem", height: "3rem", borderRadius: "10px" }}
    />
  );
};

export default MemberImage;
